import DashboardComponent from "../../Component/Dashboard/DashboardComponent";
const Dashboard = () => {
  return (
    <>
        <DashboardComponent />
    </>
  );
};
export default Dashboard;
